import React, { useState } from 'react';

const ButtonClickUserLocation = ({ buttonDetails }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 5;

  if (!buttonDetails || !buttonDetails.userLocation) {
    return <p className="text-gray-600 py-4 text-center">No location data available.</p>;
  }

  // Extract location data from buttonDetails
  const { userLocation } = buttonDetails;
  
  // Calculate pagination
  const totalPages = Math.ceil(userLocation.length / itemsPerPage);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = userLocation.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? 'Invalid Date' : date.toLocaleString();
  };

  return (
    <div className="w-full">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">Click Count History</h3>
      {/* Summary Card */}
      <div className="bg-gray-50 rounded-lg p-4 mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          {/* <div>
            <h3 className="text-sm font-semibold text-gray-600">Button ID</h3>
            <p className="text-sm text-gray-800 break-all">{buttonDetails.buttonId}</p>
          </div> */}
          <div>
            <h3 className="text-sm font-semibold text-gray-600">Button URL</h3>
            <p className="text-sm text-gray-800 break-all">
              <a
                href={buttonDetails.buttonURL}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 hover:underline"
              >
                {buttonDetails.buttonURL}
              </a>
            </p>
          </div>
          <div>
            <h3 className="text-sm font-semibold text-gray-600">Total Clicks</h3>
            <p className="text-lg text-gray-800">{buttonDetails.clickCount}</p>
          </div>
        </div>
      </div>

      {/* Location Details Table */}
      <div className="overflow-x-auto">
        <h3 className="text-xl font-semibold mb-4 text-gray-800">Location Details</h3>
        <table className="w-full border-collapse">
          <thead>
            <tr className="bg-gradient-to-r from-blue-500 to-purple-600">
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">No.</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">IP Address</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">Country</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">Region</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">City</th>
              <th className="px-4 py-3 text-left text-sm font-semibold text-white">Timezone</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.length > 0 ? (
              currentItems.map((location, index) => (
                <tr key={index} className="hover:bg-gray-50 border-b">
                  <td className="px-4 py-3 text-gray-800">
                    {(currentPage - 1) * itemsPerPage + index + 1}
                  </td>
                  <td className="px-4 py-3 text-gray-800">{location.ip || 'N/A'}</td>
                  <td className="px-4 py-3 text-gray-800">{location.country || 'N/A'}</td>
                  <td className="px-4 py-3 text-gray-800">{location.region || 'N/A'}</td>
                  <td className="px-4 py-3 text-gray-800">{location.city || 'N/A'}</td>
                  <td className="px-4 py-3 text-gray-800">{location.timezone || 'N/A'}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="6" className="text-center py-4 text-gray-600">
                  No location data available.
                </td>
              </tr>
            )}
          </tbody>
        </table>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="bg-gray-100 px-4 py-3 flex items-center justify-center space-x-2 mt-4">
            <button
              onClick={() => paginate(currentPage - 1)}
              disabled={currentPage === 1}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Previous
            </button>
            
            {[...Array(totalPages)].map((_, index) => (
              <button
                key={index}
                onClick={() => paginate(index + 1)}
                className={`px-4 py-2 text-sm font-medium rounded-lg border 
                  ${currentPage === index + 1 
                    ? 'bg-blue-500 text-white border-blue-500' 
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-50'
                  }`}
              >
                {index + 1}
              </button>
            ))}
            
            <button
              onClick={() => paginate(currentPage + 1)}
              disabled={currentPage === totalPages}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-white rounded-lg border border-gray-300 hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Next
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ButtonClickUserLocation;